const s = {
  "next": "Suivant",
  "prev": "Précédent",
  "select...": "Sélectionner…",
  "brand": "Marque",
  "select a date": "Sélectionner une date",
  "select hour": "Sélectionner une heure",
  "day": "Jour",
  "time": "Heure",
  "location": "Lieu",
  "first name": "Nom",
  "last name": "Prénoms",
  "name": "Nom",
  "appointment day": "Jour du rendez-vous",
  "email": "Email",
  "phone": "Téléphone",
  'phone_scemi': 'Téléphone',
  'phone_scemi_placeholder': '333 12345678',
  'prefix_scemi_placeholder': 'Ex. +39',
  "whatsapp": "Whatsapp",
  "appointment type": "Type de rendez-vous",
  "preferred contact": "Méthode de contact préférée",
  "preferred language": "Langue préférée",
  "product category": "Catégorie de produits",
  "notes": "Remarques",
  "subscribe to newsletter": "X",
  "slot unavailable": "",
  "choose another time slot": "",
  "confirm": "Confirmer",
  "sending": "Envoi",
  "appointment confirmed": "Merci de votre réservation!<br> Vous recevrez sous peu un e-mail de confirmation",
  "onsite": "Physique",
  "online": "Virtuel",
  "italian": "Italien",
  "english": "Anglais",
  "french": "Français",
  "chinese": "Chinois",
  "russian": "Russe",
  "japanese": "Japonais",
  "korean": "Coréen",
  "Abbigliamento Bambino": "Vêtements Enfant",
  "Abbigliamento Donna": "Vêtements Femme",
  "Abbigliamento Uomo": "Vêtements Homme",
  "Accessori": "Accessoires",
  "Arredamento": "Design d’intérieur",
  "Borse": "Sacs",
  "Calzature": "Chaussures",
  "Calzature Donna": "Chaussures de femme",
  "Calzature Uomo": "Chaussures pour hommes",
  "Fragranze": "Parfums",
  "Gioielleria": "Bijoux",
  "Occhiali Da Sole": "Lunettes De Soleil",
  "Orologi": "Montres",
  "Pelletteria": "Maroquinerie",
  "Pellicceria": "Fur Goods",
  "fill all fields": "champs obligatoires (*)",
  
  'your data': 'Tes données',
  'date and time': 'Date et heure',
  'num people': 'Nbre participants',
  'err num people': 'Sélectionnez le nombre de personnes',
  'workshop list': 'Liste des ateliers',
  'signup': 'Inscrivez-vous'
}

export default s;